<!--
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-22 17:11:59
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-09-08 15:37:01
-->
<template>
  <div :class="{ 'has-logo': showLogo }">
    <el-scrollbar wrap-class="scrollbar-wrapper">
      <el-menu
        :default-active="activeMenu"
        :collapse="isCollapse"
        :background-color="variables.menuBg"
        :text-color="variables.menuText"
        :unique-opened="isCollapse"
        :active-text-color="variables.menuActiveText"
        :collapse-transition="false"
        mode="vertical"
      >
        <sidebar-item
          v-for="route in routes"
          :key="route.path"
          :item="route"
          :base-path="route.path"
        />
      </el-menu>
    </el-scrollbar>
    <sidebar-footer :collapse="isCollapse" @toggleClick="toggleSideBar" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SidebarItem from "./SidebarItem";
import SidebarFooter from "./SidebarFooter";
import variables from "@/styles/variables.scss";
export default {
  name: "SideBarWrapper",
  components: { SidebarItem, SidebarFooter },
  computed: {
    ...mapGetters(["routes", "sidebar", "menuTabs", "userInfo", "roles"]),
    activeMenu() {
      const route = this.$route;
      const { meta, path } = route;
      // if set path, the siddebar will highlight the path you set
      if (meta.activeMenu) {
        return meta.activeMenu;
      }
      return path;
    },
    showLogo() {
      return this.$store.state.settings.sidebarLogo;
    },
    variables() {
      return variables;
    },
    isCollapse() {
      return !this.sidebar.opened;
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .el-menu-item.is-active {
  color: #00b259;
}
</style>
